import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DetailsPageTitleService } from '../../shared/services/details-page-title.service';
import { SmeService } from '../../shared/services/sme.service';
import { LetDirective } from '@ngrx/component';
import { InternalServerErrorComponent } from '../../components/internal-server-error/internal-server-error.component';
import { DownloadDetailsPageContentComponent } from '../../components/download-details-page-content/download-details-page-content.component';
import { NgTemplateOutlet } from '@angular/common';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
    selector: 'dp-service-release-details',
    templateUrl: './service-release-details.component.html',
    imports: [
        LetDirective,
        InternalServerErrorComponent,
        DownloadDetailsPageContentComponent,
        NgTemplateOutlet,
        LoaderComponent,
    ],
})
export class ServiceReleaseDetailsComponent {
  serviceRelease$ = this.activatedRoute.params.pipe(
    take(1),
    map(params => params.id),
    switchMap(id => this.smeService.getServiceReleaseById(id)),
    tap(serviceRelease => {
      this.titleService.setDetailsPageTitle(serviceRelease.displayTitle);
    }),
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly smeService: SmeService,
    private readonly titleService: DetailsPageTitleService,
    @Inject('Window') private readonly window: Window,
  ) {}

  reloadPage(): void {
    this.window.location.reload();
  }
}
